// extracted by mini-css-extract-plugin
export default {"trigger":"Tooltip_trigger__9iO27","bubble":"Tooltip_bubble__BUOM0","tooltip-in":"Tooltip_tooltip-in__l-DeG","top":"Tooltip_top__nTtno","bottom":"Tooltip_bottom__tgx+F"};